import { BatchPlan, POP_UP_ACTION } from "@components/Sales/batch.type";
import PlanCard from "./PlanCard";
import style from "./style.module.css";
import { useAtom } from "jotai";
import { FC, useEffect, useMemo, useRef } from "react";
import { findLastIndex } from "@utils/utilities";
import { planTableSelectedPlanAtom } from "@utils/store/store";

interface props {
  plans: BatchPlan[];
  selectedPlanId: string;
  triggerEvent: (actionType: POP_UP_ACTION) => void;
  selectHighestPlan?: boolean;
}

const OfferedPlans: FC<props> = ({
  plans,
  selectedPlanId,
  triggerEvent,
  selectHighestPlan,
}) => {
  const [_, setPlanTableSelection] = useAtom(planTableSelectedPlanAtom);
  const planRef = useRef<(HTMLDivElement | null)[]>([]);

  const handleView = (index: number) => {
    if (planRef?.current) {
      planRef.current[index]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };

  const lastPurchasedIndex = useMemo(() => {
    return findLastIndex(plans, (plan: BatchPlan) => plan?.isPlanPurchased);
  }, []);

  useEffect(() => {
    if (plans?.length > 0) {
      if (selectHighestPlan) {
        setPlanTableSelection(plans[plans?.length - 1]);
      } else if (selectedPlanId?.length > 0) {
        const index = plans?.findIndex(
          (plan: BatchPlan) => plan?._id === selectedPlanId,
        );

        if (index !== -1) {
          setPlanTableSelection(plans[index]);
          handleView(index);
        } else {
          setPlanTableSelection(plans[0]);
          handleView(0);
        }
      }
    }
  }, [selectedPlanId, plans]);

  return (
    <section className={style.wrapper}>
      {plans?.map((item: BatchPlan, index: number) => (
        <PlanCard
          updateRef={(val) => (planRef.current[index] = val)}
          handleView={handleView}
          index={index}
          key={index}
          plan={item}
          lastPurchasedIndex={lastPurchasedIndex}
          triggerEvent={triggerEvent}
        />
      ))}
    </section>
  );
};

export default OfferedPlans;
